export default "/assets/images/accessory-img-01.1c445718ee2ef6b8.webp";